import { render, staticRenderFns } from "./upLoader.vue?vue&type=template&id=4cdebeb9&scoped=true&"
import script from "./upLoader.vue?vue&type=script&lang=js&"
export * from "./upLoader.vue?vue&type=script&lang=js&"
import style0 from "./upLoader.vue?vue&type=style&index=0&id=4cdebeb9&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdebeb9",
  null
  
)

export default component.exports